import './floatingSquaresLoader.scss';

type Square = {
  color: 'yellow' | 'blue' | 'navy' | 'peri';
  left: number;
  top: number;
  size: number;
};

const SQUARES: Square[] = [
  { color: 'yellow', left: 10, size: 66, top: 60 },
  { color: 'blue', left: 66, size: 40, top: 26 },
  { color: 'navy', left: 44, size: 64, top: 88 },
  { color: 'peri', left: 20, size: 34, top: 140 },
  { color: 'yellow', left: 66, size: 24, top: 168 }
];

export function FloatingSquaresLoader({ className }: { className?: string }) {
  return (
    <div aria-hidden="true" className={['floatingSquaresLoader', className].filter(Boolean).join(' ')}>
      {SQUARES.map((square, index) => (
        <span
          className={`floatingSquaresLoader__square floatingSquaresLoader__square--${square.color}`}
          key={`${square.color}-${index}`}
          style={
            {
              '--floating-squares-delay': `${index * 0.15}s`,
              height: square.size,
              left: square.left,
              top: square.top,
              width: square.size
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
}

FloatingSquaresLoader.displayName = 'FloatingSquaresLoader';
